/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Component to view the service level
 * @author Heino Lenting, Maarten Lensink

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-bar-above[_ngcontent-%COMP%]{background-color:#999653}.sym-bar-above[_ngcontent-%COMP%], .sym-bar-below[_ngcontent-%COMP%]{border:1px solid rgba(0,0,0,.1)}.sym-bar-below[_ngcontent-%COMP%]{background-color:#e8a055}"];
export { styles as styles };
